import { SwitchButton } from "components/switchButton";
import { ISupportCategoryItem } from "interfaces";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { formatNumber, isHaveActionPermission } from "utills/helpers";
import { TooltipParagraph } from "components/tooltipParagraph";
import { formattedFilterParamsString } from "providerrs";

interface SupportCategoryTableProps {
  data?: ISupportCategoryItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const SupportCategoryTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: SupportCategoryTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Categories name vie
              </th>
              <th scope="col" className="th">
                Categories name eng
              </th>
              <th scope="col" className="th">
                Position
              </th>
              <th scope="col" className="th">
                Number of Q&A
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: ISupportCategoryItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  <TooltipParagraph 
                    text={item.name_vi}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  <TooltipParagraph 
                    text={item.name_en}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td overflow-x-auto">
                  {formatNumber(item.order_number)}
                </td>
                <td className="td overflow-x-auto">
                  <Link to={`/cs/support-qa?${formattedFilterParamsString([
                    {field: "category_id", operator: "eq", value: item.id}
                  ])}`} className="text-brand-500 hover:underline">
                    {formatNumber(item.number_of_qa)}
                  </Link>
                </td>
                <td className="td overflow-x-auto">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("support_categories", "cs", "edit")}
                    onChange={() => _toggleActive(item.id, item.is_active)}
                  />
                </td>
                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="flex justify-start items-center gap-x-2">
                    <Link to={`/cs/support-category/${item.id}`} className="w-fit">
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <EyeIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                    {isHaveActionPermission(
                      "support_categories",
                      "cs",
                      "edit"
                    ) ? (
                      <Link
                        to={`/cs/support-category/${item.id}/edit`}
                        className="w-fit"
                      >
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <PencilIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
